export interface User {
  email: string;
  userAccount: string;
  userId: number;
  userFullName?: string;
  blockedBy?: string;
}
